export default "__VITE_PUBLIC_ASSET__a0bbe210__"